export { getDictionary } from './getDictionary';
export { revalidateDictionary } from './revalidateDictionary';
